import { HttpClient } from '@angular/common/http';
import { Injectable,signal } from '@angular/core';
import { BehaviorSubject, concatMap, tap, Observable, finalize } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ROLES } from './constants/Roles.constant';
import { CommonService } from './trip-replay/services/common.service';

@Injectable({
  providedIn: 'root'
})
export class DataService {
  buid: string = '';
  roleId: number = 0;
  ETS_BUID:string = ''

  MASTER_PROPERTIES = [
    "HIDE_EMP_PHONE_NO_FROM_VENDORS",
    "HIDE_EMP_ADDRESS_FROM_VENDORS",
    "TEXT_SHOWN_FOR_HIDDEN_INFO_TO_VENDORS",
    "ENABLE_CAB_ARRIVED",
    "ENABLE_NO_SHOW_EMPLOYEE_NOTIFICATION",
    "FEATURE_CLICK2CALL_ENABLED",
    "TRIP_DELAY_GRACE_TIME_SECONDS",
    "LOGOUT_TRIP_DELAY_GRACE_TIME_SECS",
    "ROUTING_EMPLOYEE_SERVICE_TIME_MIN",
    "ENABLE_ADMIN_AI_BOT",
    'SHOW_EMPLOYEE_FIXED_DEVICE_TRAVELLED_DISTANCE',
    "AI_BOT_URL",
    "ALLOW_SIGNOUT_EMPLOYEES_ON_TRIP_VIEW",
    "FEATURE_INCLUDE_TOLLS_IN_DRIVING_DISTANCE_CALCULATION"
  ];

  private etsPropertiesSubject = new BehaviorSubject<Record<string, any>>({});
  public ETS_PROPERTIES$ :any = this.etsPropertiesSubject.asObservable();
  public ETS_PROPERTIES_LOADED$ = new BehaviorSubject<boolean>(false);
  public isFdDistanceEnabled = signal<boolean>(false);
  public isAllowSignoutEmployeesOnTripView = signal<boolean>(false);
  isAvoidTollsEnabled=signal<boolean>(false);
  
  isVendorRole(){
    return [ROLES.ROLE_VM, ROLES.ROLE_V_BILLING_MGR, ROLES.ROLE_PLATFORM_V_BILLING_MGR]
    .includes(this.roleId)
  }

  constructor(private http: HttpClient, private tripReplayCommonService:CommonService) {}

  getPropertyValue() {
    return this.http.get<any[]>(`${environment.API_URL}/empexp/ets/${this.buid}/${this.MASTER_PROPERTIES.join(',')}`).pipe(
      tap((properties: any[]) => {
        if (properties) {
          const propertyObj: Record<string, any> = {};
          properties.forEach((property: any) => {
            let { propertyName, propertyValue } = property;
            propertyValue = propertyValue === "false" ? false : propertyValue === "true" ? true : propertyValue;
            propertyObj[propertyName] = propertyValue;
          });
          propertyObj['ROLE'] = this.roleId;
          console.log('properties are : ', propertyObj)
          this.tripReplayCommonService.TRIP_DELAY_LOGIN_GRACE_SECS = propertyObj['TRIP_DELAY_GRACE_TIME_SECONDS']
          this.tripReplayCommonService.TRIP_DELAY_LOGOUT_GRACE_SECS = propertyObj['LOGOUT_TRIP_DELAY_GRACE_TIME_SECS']
          this.tripReplayCommonService.EMPLOYEE_GRACE_TIME_MIN = propertyObj['ROUTING_EMPLOYEE_SERVICE_TIME_MIN'];
          this.isFdDistanceEnabled.set(propertyObj['SHOW_EMPLOYEE_FIXED_DEVICE_TRAVELLED_DISTANCE']);
          this.isAllowSignoutEmployeesOnTripView.set(propertyObj['ALLOW_SIGNOUT_EMPLOYEES_ON_TRIP_VIEW'] ?? false);
          this.isAvoidTollsEnabled.set(!(propertyObj?.['FEATURE_INCLUDE_TOLLS_IN_DRIVING_DISTANCE_CALCULATION'] ?? false))
          this.etsPropertiesSubject.next(propertyObj);
        }
      }),
      finalize(() => {
        this.ETS_PROPERTIES_LOADED$.next(true);
      })
    );
  }

  getEtsSiteURL(){
    return this.http.get(`${environment.API_URL}/dashboard/${this.buid}/url`, { responseType : 'text' }).pipe(
      tap((value:string) => {
        this.constructBuid(value)
        }
       )
    )
  }

  constructBuid(url:string){
    const etsURL = new URL(url)
    const buidFirstHalf = etsURL.hostname.split('.')[0]
    const buidSecondHalf = etsURL.pathname.replace(/\//g, '')
    this.ETS_BUID = `${buidFirstHalf}-${buidSecondHalf}`
  }
}
